import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {FavoritesManager} from '../../data/manager/favorites/favorites.manager';
import { CustomerManager } from '../../data/manager/customer/customer/customer.manager';

@Injectable({
  providedIn: 'root',
})
export class FavoritesButtonVm {

  constructor(private favoritesManager: FavoritesManager, private customerManager: CustomerManager) { }

  addRemove(item): Observable<any> {
    return this.favoritesManager.addRemove(item);
  }

  isFavorite( product ) {
    return this.favoritesManager.isFavorite( product );
  }

  hasCustomer() {
    return this.customerManager.hasValidCustomer();
  }

}
